import AvailableCreditModal from './AvailableCreditModal';

export default AvailableCreditModal;
